/**
 * Case-insensitive search helper for the prototype's table pages. Returns
 * `items` filtered to those where any extracted string contains the search
 * term. An empty / whitespace-only search returns the original list.
 */
export function filterByText<TItem>(
  items: readonly TItem[],
  search: string,
  getFields: (item: TItem) => ReadonlyArray<string | null | undefined>,
): TItem[] {
  const lower = search.trim().toLowerCase();
  if (!lower) {
    return [...items];
  }
  return items.filter((item) =>
    getFields(item).some((field) => (field ?? '').toLowerCase().includes(lower)),
  );
}
